"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _color = require("../../../../theme/color/index.js");
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _jsxRuntime = require("react/jsx-runtime");
var _CartesianGrid, _defs;
const AreaChartComponent = props => {
  const {
    width = 300,
    height = 200,
    data = [],
    dataKey,
    //X axis label. Usually an object's property
    chartDataKey,
    //Based on this data, graphs will appear.  Usually an object's property
    margin = {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    },
    barSize = 10,
    barRadius = [10, 10, 0, 0],
    innerRadius = 100,
    barColor = _color.Color.Purple3,
    tooltipStatus = true,
    grid = false,
    labelData = undefined,
    xAxisFontSize = '10px',
    yAxisFontSize = '10px',
    customTooltip
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
    width: width,
    height: height,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.AreaChart, {
      data: data || [],
      margin: margin,
      children: [grid && (_CartesianGrid || (_CartesianGrid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
        strokeDasharray: "1"
      }))), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, {
        dataKey: dataKey,
        tick: {
          fontFamily: 'Nunito Sans',
          fontSize: xAxisFontSize
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, {
        tick: {
          fontFamily: 'Nunito Sans',
          fontSize: yAxisFontSize
        }
      }), tooltipStatus && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
        content: customTooltip
      }), _defs || (_defs = /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
          id: "colorPv",
          x1: "0",
          y1: "1",
          x2: "0",
          y2: "0",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
            offset: "20%",
            stopColor: "#1A50FF",
            stopOpacity: 0.5
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
            offset: "100%",
            stopColor: "#1ee9b6",
            stopOpacity: 0.24
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
            offset: "100%",
            stopColor: "#fff",
            stopOpacity: 0
          })]
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Area, {
        type: "monotone",
        dataKey: chartDataKey,
        fill: "url(#colorPv)",
        stroke: "url(#colorPv)"
      })]
    })
  });
};
var _default = exports.default = AreaChartComponent;
module.exports = exports.default;
module.exports.default = exports.default;